(function () {
    'use strict';

    angular.module('app.galleries', [
        // Angular modules
        'ngRoute'

        // Custom modules

        // 3rd Party Modules

    ]);
})();